import { patientAction } from 'src/redux/actions/constant';

const { RESET_UPLOAD_CSV_TEMPLATE, SUCCESS_UPLOAD_CSV_TEMPLATE, FAILURE_UPLOAD_CSV_TEMPLATE } =
  patientAction;

const intitialstate: object = {
  isUploadSuccess: false,
  response: null,
};

export const uploadCsvTemplateReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_UPLOAD_CSV_TEMPLATE: {
      return {
        ...state,
        isUploadSuccess: true,
        response: action.payload,
      };
    }

    case FAILURE_UPLOAD_CSV_TEMPLATE:
      return {
        ...state,
        isUploadSuccess: false,
        response: action.payload,
      };

    case RESET_UPLOAD_CSV_TEMPLATE:
      return intitialstate;

    default:
      return state;
  }
};
